import { useEffect, useState } from 'react';

import { api, type Period } from '../api/endpoints';
import type { Category, EventCard } from '../api/types';
import { EventCardView } from '../components/EventCardView';

const PERIODS: { key: Period; label: string }[] = [
  { key: 'today', label: 'Сегодня' },
  { key: 'week', label: 'Неделя' },
  { key: 'upcoming', label: 'Все' },
  { key: 'past', label: 'Прошедшие' },
];

interface Props {
  onOpenEvent: (id: number) => void;
}

export function EventsPage({ onOpenEvent }: Props) {
  const [categories, setCategories] = useState<Category[]>([]);
  const [category, setCategory] = useState<string | undefined>();
  const [period, setPeriod] = useState<Period>('upcoming');
  const [events, setEvents] = useState<EventCard[] | null>(null);

  useEffect(() => {
    api.categories().then(setCategories).catch(() => setCategories([]));
  }, []);

  useEffect(() => {
    setEvents(null);
    api
      .events({ category, period })
      .then(setEvents)
      .catch(() => setEvents([]));
  }, [category, period]);

  return (
    <div className="screen">
      <h1 className="screen__title">Мероприятия</h1>

      <div className="filters">
        {PERIODS.map((item) => (
          <button
            key={item.key}
            className={`pill ${period === item.key ? 'pill--active' : ''}`}
            onClick={() => setPeriod(item.key)}
          >
            {item.label}
          </button>
        ))}
      </div>

      <div className="filters">
        <button
          className={`pill ${!category ? 'pill--active' : ''}`}
          onClick={() => setCategory(undefined)}
        >
          Все
        </button>
        {categories.map((item) => (
          <button
            key={item.id}
            className={`pill ${category === item.code ? 'pill--active' : ''}`}
            onClick={() => setCategory(item.code)}
          >
            {item.name}
          </button>
        ))}
      </div>

      {events === null ? (
        <div className="skeleton" />
      ) : events.length === 0 ? (
        <p className="muted">
          {period === 'past'
            ? 'Прошедших мероприятий пока нет.'
            : 'Здесь пока пусто. Ближайшие события появятся скоро.'}
        </p>
      ) : (
        <div className="cards">
          {events.map((event) => (
            <EventCardView key={event.id} event={event} onOpen={onOpenEvent} />
          ))}
        </div>
      )}
    </div>
  );
}
